import mapTypes, { mapLevelTypes } from "./map.types";

const INITIAL_STATE = {
  sourceLocation: "",
  destinationLocation: "",

  centerOfMap: "",
  centerOfMapAddress: "",
  centerOfMapAddressIsLoading: false,

  //   shownAddressIsLoading: false,

  mapLeftOverlayShow: false,

  suggestions: [],
  suggestionsIsLoading: false,

  suggestions_show: false,

  level: mapLevelTypes.SOURCE,
  goLevel_4: true,

  bottomWhite_long: false,

  sourceLoaction_justSet: false,
};

const mapReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case mapTypes.SET_CENTEROFMAP:
      return {
        ...state,
        centerOfMap: action.payload,
      };

    // get center address
    case mapTypes.FETCH_CENTEROFMAPADDRESS_START:
      return {
        ...state,
        centerOfMapAddressIsLoading: true,
      };

    case mapTypes.FETCH_CENTEROFMAPADDRESS_SUCCESS:
      return {
        ...state,
        centerOfMapAddressIsLoading: false,
        centerOfMapAddress: action.payload,
      };

    //OVERLAYS
    case mapTypes.TOGGLE_MAPLEFTOVERLAY_SHOW:
      return {
        ...state,
        mapLeftOverlayShow: action.payload,
      };

    // map level
    case mapTypes.SET_MAP_LEVEL:
      return {
        ...state,
        level: action.payload,
      };

    case mapTypes.INCREASE_MAP_LEVEL:
      return {
        ...state,
        level: state.level + 1,
      };

    case mapTypes.DECREASE_MAP_LEVEL:
      return {
        ...state,
        level: state.level - 1,
      };

    //

    //seggestion
    case mapTypes.FETCH_ADDRESSSUGGESTIONS_START:
      return {
        ...state,
        suggestionsIsLoading: true,
      };
    case mapTypes.FETCH_ADDRESSSUGGESTIONS_SUCCESS:
      return {
        ...state,
        suggestionsIsLoading: false,
        suggestions: action.payload,
      };
    case mapTypes.SET_SUGGESTIONS_SHOW:
      return {
        ...state,
        suggestions_show: action.payload,
      };
    //

    // long white
    case mapTypes.SET_BOTTOMWHITE_LONG:
      return {
        ...state,
        bottomWhite_long: action.payload,
      };

    //

    // go level 4
    case mapTypes.SET_GOLEVEL_4:
      return {
        ...state,
        goLevel_4: action.payload,
      };
    //

    // source location just set
    case mapTypes.SET_SOURCELOCATION_JUSTSET:
      return {
        ...state,
        sourceLoaction_justSet: action.payload,
      };
    //

    default:
      return state;
  }
};

export default mapReducer;
